// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"detailschart_modalHeader__aHGIR","chartContainer":"detailschart_chartContainer__3hrlB","modalFooter":"detailschart_modalFooter__28qfS"};